module.exports = __webpack_public_path__ + "img/icon_box_1_3.3e83513a.png";